<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    items?: {
      title: string
      description?: string
    }[]
  }>(),
  {
    title: 'Cara Install Plugin KiriminAja, Prosesnya Mudah dan Cepat',
    items: () => [
      {
        title: 'Install Plugin KiriminAja di Shopify',
        description: 'Langsung dari App Store resmi Shopify'
      },
      {
        title: 'Pilih Kurir & Atur Tarif Pengiriman Otomatis',
        description: 'Multi Ekspedisi aktif dengan satu klik'
      },
      {
        title: 'Order Masuk, Resi Otomatis Terbit',
        description: 'Tanpa input manual, tanpa kesalahan'
      },
      {
        title: 'Pelanggan Cek Resi & Status Real-Time',
        description: 'Transparan, cepat, dan bikin mereka percaya!'
      }
    ]
  }
)
</script>

<template>
  <div class="py-6 lg:py-16 relative overflow-hidden">
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-6 lg:gap-11 relative z-10">
      <UiSectionTitle
        class="text-center"
        title="Cara Install Plugin KiriminAja, Prosesnya Mudah dan Cepat"
        description="Ikuti langkah-langkah berikut untuk menginstall dan mengatur plugin KiriminAja di toko online Shopify kamu."
      />
      <div class="grid lg:grid-cols-6 gap-5">
        <div class="lg:col-span-2 space-y-3">
          <UiCardFeature
            v-for="(item, key) in items"
            :key="key"
            :icon="`material-symbols:counter-${key + 1}-outline`"
            icon-size="24px"
            :title="item.title"
            wrapper-class="flex-row"
            title-class="lg:text-base"
            :description="item.description"
          />
        </div>

        <div class="lg:col-span-4">
          <UiPlayerYoutube video-id="CEGNQHsucOU" />
        </div>
      </div>
    </UiContainer>
  </div>
</template>
